<div class="body">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>location_on</mat-icon>
        </button>
        <span>Standort auswählen</span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="fill">

            <mat-label>Standort suchen</mat-label>
            <input type="text" placeholder='Suchbegriff eingeben' matInput [formControl]="formControl"
                (keyup.enter)="search()" autocomplete="off" />
            <mat-icon matSuffix>search</mat-icon>

        </mat-form-field>

        <div class="results preview-entry-container" *ngIf="locations.length > 0; else noLocations">

            <div class="preview-entry" *ngFor="let location of locations" (click)="locationClicked(location)">
                <app-location-preview [location]="location"></app-location-preview>
            </div>

            <div class="load-more-wrapper" *ngIf="total > locations.length">

                <button mat-raised-button (click)="loadMore()">
                    Mehr laden
                </button>

            </div>

        </div>

        <div class="footer">

            {{locations.length}} von {{total}}
    
        </div>

    </div>

</div>

<ng-template #noLocations>

    <div class="no-locations-hint">

        <div class="text">Kein Standort gefunden</div>

    </div>

</ng-template>
